











































import Vue from 'vue';
import { getCurrentLocationMixin } from '@/mixins/getCurrentLocationMixin';
import { LocationInterface } from '@/utils/location';

export default Vue.extend({
    name: 'NewPlaceView',
    mixins: [
        getCurrentLocationMixin,
    ],
    methods: {
        useCurrentLocation() {
            this.getCurrentLocation()
                .then((location: LocationInterface) => {
                    this.$router.push(
                        {
                            name: 'new-place-search',
                            params: {
                                latlon: location.lat + ',' + location.lon,
                            },
                        },
                    );
                });
        },
    },
});
